export class RiskOption {
    id: string = '';
    name: string = '';
}

export class RiskOptionSetting {
    en: RiskOption[] = [];
    de: RiskOption[] = [];
}